// extracted by mini-css-extract-plugin
export default {"modalHeader":"AttributeFilterModal_modalHeader__2ItGf","checkbox":"AttributeFilterModal_checkbox__J5VUv"};